import { usePageAssets } from "hooks/usePageAssets"
import Heading from "components/ui/Heading"
import DecoratedSection from "components/ui/Layout/DecoratedSection"
import SplitContainer from "components/ui/Layout/SplitContainer"

function TimeToMarketSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("customer-apps-time-to-market-svg")
  return (
    <DecoratedSection reversed>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-10 lg:mt-10 xl:w-1/3 mx-auto xl:ml-10"
        reversed
      >
        <Heading
          label="Time to Market"
          title="Launch data-driven apps faster with full customization"
          subtitle={
            <>
              Use pre-installed charts and a no-code editor to quickly embed
              interactive analytics in your product. Fine-tune colors, fonts,
              annotations, and more for a seamless on-brand product experience.
            </>
          }
          narrow
        />
      </SplitContainer>
    </DecoratedSection>
  )
}

export default TimeToMarketSection
